import { Typography } from 'omakase';
import BallPulse from '@tock/shared/components/BallPulse';
import Portal from '@tock/shared/components/Portal';

interface Props {
  isLocking: boolean;
}

export default (props: Props) => {
  return (
    <Portal isOpen={props.isLocking}>
      <div className="ConsumerModal-loadingOverlay">
        <div className="ConsumerModal-loadingOverlayBody">
          <div className="ConsumerModal-loadingOverlayText">
            <Typography color="inherit" component="span" variant="body02">
              Checking availability...
            </Typography>
          </div>
          <div className="ConsumerModal-loadingOverlaySpinner">
            <BallPulse position="INLINE" data-testid="SearchModalRouteBallPulse" />
          </div>
        </div>
      </div>
    </Portal>
  );
};
